import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { LineOfBusiness, UserType } from 'identity-management';
import { ProductsService, UserService } from 'shared-data-access';
import { AppRoutes } from 'shared-utils';

export const productGuard: CanActivateFn = (): UrlTree | boolean => {
  const productsService = inject(ProductsService);
  const router = inject(Router);

  const product: LineOfBusiness = productsService.selectedProduct;

  if (!product) {
    return router.createUrlTree([AppRoutes.Default]);
  }

  if (isInternalWithoutSelectedTenant(productsService.tenantId)) {
    return router.createUrlTree([AppRoutes.Products]);
  }
  return !!product;

  function isInternalWithoutSelectedTenant(tenantId: string): boolean {
    const userService = inject(UserService);
    const isInternalUser = userService.getType() === UserType.Internal;
    return isInternalUser && !tenantId;
  }
};
